import { lazy } from "react";
import { Settings as SettingsIcon } from "lucide-react";
import type { AdminPlugin } from "@/plugins/types";

const Settings = lazy(() => import("@/pages/admin/Settings"));

const settingsPlugin: AdminPlugin = {
  id: "settings",
  label: "Settings",
  icon: SettingsIcon,
  route: "settings",
  component: Settings,
  menuOrder: 10,
};

export default settingsPlugin;
